import { Form, InputNumber } from 'antd';
import React from 'react';

const NumericOperations = ({
  label,
  placeholder,
  value,
  onChange,
  fieldNamePrefix = [],
  paramKey = 'value',
}) => {
  return (
    <Form.Item
      label={label}
      name={[...fieldNamePrefix, paramKey]}
      rules={[
        {
          required: true,
          message: 'Veuillez saisir un opérateur numérique',
        },
      ]}
      initialValue={value}
    >
      <InputNumber
        placeholder={placeholder}
        onChange={(val) => onChange(val)}
        style={{ width: '100%' }}
        controls={false}
      />
    </Form.Item>
  );
};

export default NumericOperations;
